"use client";

import FeedbackButton from "@/components/feedback/FeedbackButton";

type FeedbackSectionProps = {
  mode?: "public" | "customer";
  className?: string;
};

export default function FeedbackSection({ mode = "public", className = "" }: FeedbackSectionProps) {
  void mode;

  return (
    <section className={`w-full ${className}`} data-testid="homepage-feedback-section">
      <div className="mx-auto w-full max-w-5xl px-5 pb-14 pt-6 text-center sm:px-6 sm:pb-16 sm:pt-7 md:px-8 md:pb-20 md:pt-8">
        <h2 className="text-base sm:text-lg font-medium text-slate-800">
          Help us improve YourBarrio
        </h2>
        <p className="mt-2 text-sm text-slate-600">
          YourBarrio is in beta. Found something confusing, have an idea, or just want to tell us how we&apos;re doing?
        </p>
        <div className="mt-4 flex items-center justify-center">
          <FeedbackButton
            source="homepage"
            className="text-sm font-medium text-[#5b21b6] transition-colors hover:text-[#411991] hover:underline underline-offset-4"
          >
            Give feedback
          </FeedbackButton>
        </div>
      </div>
    </section>
  );
}
